import notifier from './../lib/notifier';

function getModelStateErrors(modelState) {
    const errors = [];
    for (let key of Object.keys(modelState)) {
        errors.push((key ? `${key}: ` : '') + `${modelState[key].join(', ')}`);
    }

    return errors.join('; ');
}

function getErrorMessage(response) {
    if (response.type === 'application/json' && response.body) {
        if (response.body.message) {
            if (response.body.modelState) {
                return response.body.message + ' ' + getModelStateErrors(response.body.modelState)
            }

            return response.body.message;
        }

        return JSON.stringify(response.body, null, 2);
    }

    return response.text;
}

export default function handleRequestError(error) {
    const response = error.response;

    if (response) {
        const isHtml = response.type === 'text/html';
        const title = `${response.statusText} ${response.statusCode}`;
        const message = isHtml ? '' : getErrorMessage(response);

        const action = isHtml
            ? {
                label: 'View error detail',
                callback: function () {
                    const errorResponseWindow = window.open('', 'errorResponseWindow', 'toolbar=1,scrollbars=1,location=1,statusbar=0,menubar=1,resizable=1,width=800,height=600');
                    errorResponseWindow.document.write(response.text);
                }
            }
            : null;

        notifier.notify({
            level: notifier.Level.Error,
            title: title,
            message: message,
            action
        });
    }
    else {
        if (error.message) {
            notifier.notify({
                level: notifier.Level.Error,
                title: 'Error',
                message: error.message
            });
        }
        else if (typeof error === "object") {
            notifier.notify({
                level: notifier.Level.Error,
                title: 'Error',
                message: JSON.stringify(error, null, 2)
            });
        } else {
            notifier.notify({
                level: notifier.Level.Error,
                title: 'Error',
                message: 'An error occurred, please check console for details.'
            });

            console.log(error);
        }
    }
}